import { render } from "./StripeBox.vue?vue&type=template&id=6a45798e&scoped=true"
import script from "./StripeBox.vue?vue&type=script&lang=ts"
export * from "./StripeBox.vue?vue&type=script&lang=ts"

import "./StripeBox.vue?vue&type=style&index=0&id=6a45798e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a45798e"

export default script